import { jsx as _jsx } from "react/jsx-runtime";
import sidebarIcon from '@/core/svg/fa/light/sidebar.svg';
import { SvgIcon } from '@/core/ui';
import { useLayoutStore } from '@/shared/modules/layout/business';
import { LinkIconButton } from './SidebarToggleButton.styled';
const SidebarToggleButton = () => {
    const toggleSidebarWidth = useLayoutStore((state) => state.toggleSidebarWidth);
    const handleButtonClick = () => {
        toggleSidebarWidth();
    };
    return (
    // Not impossible to add Tooltip here without visual bugs.
    _jsx(LinkIconButton, { size: "medium", onClick: handleButtonClick, disableRipple: true, children: _jsx(SvgIcon, { size: "xl", icon: sidebarIcon }) }));
};
export { SidebarToggleButton };
